import clsx from "clsx";
import Image from "next/image";

import { getDateText } from "koljobs-helpers/src/helpers/getDateText";

import { useUserContext } from "@/features/auth/contexts/useUserContext";
import { useSubscriberAuth } from "@/features/businessSubscription/hooks/useSubscriberAuth";
import {
  useConfirmDialogContext,
  withConfirmDialog,
} from "@/features/common/contexts/useConfirmDialogContext";
import {
  DialogViewEnum,
  useDialogContext,
} from "@/features/common/contexts/useDialogContext";
import { UserRoleEnum } from "@/generated/graphql-hooks";

type LastOnlineItemType = {
  lastOnlinedAt?: string;
};

function LastOnlineItem({ lastOnlinedAt }: LastOnlineItemType) {
  const { isSubscriber } = useSubscriberAuth();
  const { user } = useUserContext();
  const { openDialog } = useDialogContext();
  const { openConfirmDialog } = useConfirmDialogContext();

  function handleItemClick() {
    if (isSubscriber) return;
    if (!user) {
      openConfirmDialog({
        content: "請先登入/註冊，才能使用此功能",
        hideActionButtons: true,
      });

      return;
    }

    openDialog({ view: DialogViewEnum.JoinSubscriptionDialog });
  }

  if (!lastOnlinedAt) return null;
  if (user?.role === UserRoleEnum.Model) return null;

  return (
    <span
      className={clsx(
        "flex justify-end space-x-2 text-gray-400",
        !isSubscriber && "cursor-pointer hover:opacity-70",
      )}
      onClick={handleItemClick}
    >
      <Image
        alt="KOL last online"
        src="/images/icons/profile/crown.svg"
        width={20}
        height={20}
        className="mr-2"
      />
      最後上線時間
      {" " +
        (isSubscriber ? getDateText(new Date(lastOnlinedAt)) : "(VIP商戶查看)")}
    </span>
  );
}

export default withConfirmDialog(LastOnlineItem);
